import React, { useState } from "react";
import { images } from "../../assets/images";
import { useGlobal } from "../../context/GlobalContext";

const ResetPassword = () => {
  const { userData, updateUserData, setPassword } = useGlobal();
  const [showPassword, setShowPassword] = useState({
    newPass: false,
    confirmPass: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setPassword();
  };

  return (
    <section className="login-section-bg">
      <div className="container-main d-flex flex-column justify-content-center">
        <div className="d-flex justify-content-center">
          <div className="auth-logo">
            <img
              src={images.pureTouchLogo}
              alt="app-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.appLogo;
              }}
            />
          </div>
        </div>

        <div className="card auth-card mb-5">
          <h5 className="mb-4 text-center text-primary fw-semibold">
            Reset Password
          </h5>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                OTP
                {!userData.otp && <span className="text-danger"> *</span>}
              </label>
              <input
                type="number"
                maxLength={6}
                value={userData.otp}
                onChange={(e) => updateUserData("otp", e.target.value)}
                className="form-control input-tags"
                placeholder="Enter OTP"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">
                New Password
                {!userData.setPassword && <span className="text-danger"> *</span>}
              </label>

              <div className="form-group position-relative mb-2">
                <input
                  type={showPassword.newPass ? "text" : "password"}
                  value={userData.setPassword}
                  onChange={(e) =>
                    updateUserData("setPassword", e.target.value)
                  }
                  className="form-control input-tags input-tags-grouped"
                  placeholder="Enter new password"
                />
                <span
                  className="eye-icon"
                  onClick={() =>
                    setShowPassword((prev) => ({
                      ...prev,
                      newPass: !prev.newPass,
                    }))
                  }
                >
                  <i
                    className={`fa-solid ${
                      showPassword.newPass ? "fa-eye-slash" : "fa-eye"
                    }`}
                  ></i>
                </span>
              </div>
            </div>
            <div className="mb-2">
              <label className="form-label">
                Confirm Password
                {!userData.confirmPassword && <span className="text-danger"> *</span>}
              </label>

              <div className="form-group position-relative mb-2">
                <input
                  type={showPassword.confirmPass ? "text" : "password"}
                  value={userData.confirmPassword}
                  onChange={(e) =>
                    updateUserData("confirmPassword", e.target.value)
                  }
                  className="form-control input-tags input-tags-grouped"
                  placeholder="Re-enter password"
                />

                <span
                  className="eye-icon"
                  onClick={() =>
                    setShowPassword((prev) => ({
                      ...prev,
                      confirmPass: !prev.confirmPass,
                    }))
                  }
                >
                  <i
                    className={`fa-solid ${
                      showPassword.confirmPass ? "fa-eye-slash" : "fa-eye"
                    }`}
                  ></i>
                </span>
              </div>
            </div>

            <div className="mt-4 text-center">
              <button type="submit" className="btn btn-primary mt-1">
                Set Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
